<li class="bullet-item" [ngClass]="{'gp-preview': isGpPreview}" *ngIf="value !== null && value !== undefined">

  <label class="bullet-label">
    <ng-content></ng-content>
  </label>
  <span class="values-wrapper pt-1" [ngClass]="{'unit-left': isUnitBeforeValue, 'unit-right': !isUnitBeforeValue }">
    <span class="bullet-value-and-unit">
      <span class="unit" *ngIf="isUnitBeforeValue">{{unit}}</span>
      <span class="value">{{value | terraNumber : fractionSize}}</span>
      <!-- Display the to-value only if it exists, and different from the minimum value -->
      <ng-container *ngIf="toValue !== null && toValue !== undefined && toValue !== value">
        <span class="dash">-</span>
        <span class="value">{{toValue | terraNumber: fractionSize}}</span>
      </ng-container>
      <span class="unit" *ngIf="!isUnitBeforeValue">{{unit}}</span>
    </span>
  </span>
</li>
